import { baseUrl } from 'infra/config/aws-env'
import { ClinicsService } from 'infra/services/clinics-service'
import { makeAxiosHttpClient } from '../http/axios-http-client-factory'

export const makeClinicsService = (): ClinicsService => new ClinicsService(baseUrl, makeAxiosHttpClient())
